var components
try {
  components = {
    navBar: function () {
      return import(
        /* webpackChunkName: "components/navBar/navBar" */ "@/components/navBar/navBar.vue"
      )
    },
    diy: function () {
      return import(
        /* webpackChunkName: "components/diy/diy" */ "@/components/diy/diy.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var m2 = _vm.topBarTop()
  var m3 = _vm.topBarHeight()
  var m4 = !(m3 == 0) ? _vm.topBarHeight() : null
  var g0 =
    _vm.index_open_city == 1
      ? _vm.index_cityname.substr(0, 3) || "未定位"
      : null
  var m5 = _vm.topBarHeight()
  var l0 =
    _vm.thisindex != 0
      ? _vm.__map(_vm.product_list, function (pitem, pindex) {
          var $orig = _vm.__get_orig(pitem)
          var m6 =
            _vm.index_open_city == 0 ||
            (_vm.index_open_city == 1 &&
              _vm.isInArray2(_vm.city_supplier_ids, pitem.shop_supplier_id))
          return {
            $orig: $orig,
            m6: m6,
          }
        })
      : null
  var g1 =
    _vm.thisindex != 0 ? _vm.product_list.length == 0 && !_vm.loading : null
  var m7 = _vm.is_collection ? _vm.topBarTop() : null
  var m8 = _vm.is_collection ? _vm.topBarHeight() : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showSearch = true
    }
    _vm.e1 = function ($event) {
      _vm.is_collection = false
    }
    _vm.e2 = function ($event) {
      _vm.is_follow = 0
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        g0: g0,
        m5: m5,
        l0: l0,
        g1: g1,
        m7: m7,
        m8: m8,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }